// src/pages/BlogPost.tsx
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import DOMPurify from "dompurify";
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";
import { usePost } from "../hooks/usePost";

import GetInTouch from '../components/GetInTouch';

import { useGsapImageReveal } from "../hooks/useGsapImageReveal";

const BlogPost: React.FC = () => {

useGsapImageReveal("blogSlug");

  const { slug } = useParams<{ slug?: string }>();

  // Call the hook unconditionally, pass slug or empty string
  const { data: post, isLoading, isError } = usePost(slug || "");

  // Redirect only after hook call
  if (!slug) return <Navigate to="/blog" />;

  if (isLoading) return <p>Loading...</p>;
  if (isError || !post) return <p>Post not found</p>;

  const img = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
  const seoTitle = (post.title?.rendered || "").replace(/(<([^>]+)>)/gi, "");
  const seoDesc = (post.excerpt?.rendered || "").replace(/(<([^>]+)>)/gi, "");

  return (
    <>
      <SEO
        title={`${seoTitle} | Manikarn Digital`}
        description={seoDesc}
        url={`https://manikarndigital.com/blog/${post.slug}`}
        image={img || seoConfig.blog.image}
      />


      {/* Breadcrumb area here */}
      <div className="rts-breadcrumb-area-blogslug bg_image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="baread-crumb-main-wrapper pt--100">
                <div className="inner">
                  <h1 className="title rts_hero__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                  <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


{/* rts about area start */}
<div className="rts-about-area-1 pt--20 pb--80">
  <div className="container">
    <div className="row g-5">
      
      {/* Image Column */}
      <div className="col-lg-5">
        <div className="sticky-image mt--10">
          {img && (
            <img
              src={img}
              alt={seoTitle}
              className="img-fluid mt--5 rts-reveal-image-one"
              style={{
                height: "350px",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center",
                border: "1px solid #414141",
                padding: "20px",
              }}
            />
          )}
        </div>
      </div>

      {/* Text Column */}
      <div className="col-lg-7 blog-content">
        <article
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(post.content.rendered),
          }}
        />
      </div>
    </div>
  </div>
</div>
{/* rts about area end */}


      {/* ==== GetInTouch Section start ==== */}
      <GetInTouch />
      {/* ==== / GetInTouch Section end ==== */}





    </>
  );
};

export default BlogPost;
